import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxContainer } from '../../incidentForm/fields/customCheckbox/style';

const CheckboxComponent = ({ field, onChange, value, disabledField }) => {
  const onChangeInput = (e) => {
    onChange(e.target.checked);
  };

  return (
    <>
      <CheckboxContainer>
        <Checkbox id={field.idInput} onChange={onChangeInput} defaultChecked={value} disabled={disabledField}>
          {field.label}
        </Checkbox>
      </CheckboxContainer>
    </>
  );
};

export default CheckboxComponent;

CheckboxComponent.propTypes = {
  field: PropTypes.object,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};
